import React from 'react';

export interface TableProps extends React.TableHTMLAttributes<HTMLTableElement> {
  className?: string;
  children: React.ReactNode;
  striped?: boolean;
  bordered?: boolean;
  hover?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const Table: React.FC<TableProps> = ({
  className = '',
  children,
  striped = false,
  bordered = false,
  hover = true,
  size = 'md',
  ...props
}) => {
  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  const tableClasses = [
    'w-full border-collapse',
    striped ? 'bg-[var(--color-gray-50)]' : '',
    bordered ? 'border border-[var(--color-gray-300)]' : '',
    hover ? 'hover:bg-[var(--color-gray-100)]' : '',
    sizeClasses[size]
  ].filter(Boolean).join(' ');

  const combinedClasses = `${tableClasses} ${className || ''}`;

  return (
    <table className={combinedClasses} {...props}>
      {children}
    </table>
  );
};
